// Single owner of window.dataLayer writes (the gtm.ts bootstrap aside).
// Lazily creates the array because gtm.ts only creates it when VITE_GTM_ID
// is set (prod) — in every other environment pushes must still be safe
// no-ops that accumulate in a plain array.
type DataLayerWindow = typeof window & { dataLayer?: unknown[] };

export type DataLayerEvent = { event: string } & Record<string, unknown>;

export function pushDL(payload: DataLayerEvent): void {
  if (typeof window === 'undefined') return;
  const w = window as DataLayerWindow;
  try {
    (w.dataLayer ??= []).push(payload);
  } catch {
    // A third-party script (GTM variants, ad blockers) can replace
    // window.dataLayer with a non-array shim without .push. Analytics is
    // best-effort by definition — a broken data layer must never take a
    // product flow (e.g. the onboarding redirect) down with it.
  }
}

// GA4 user_id is the INTERNAL users-table id (session.userId from
// /me/context), never Clerk's user id — analytics rows must join back to
// the internal database. Pushed as an event so GTM can both read the
// variable and trigger on the transition.
export function setAnalyticsUserId(userId: string | null): void {
  pushDL({ event: 'user_id_set', user_id: userId });
}
